import { Link } from "react-router-dom";

export function TerraButton({ children, to, href, external = false, testid, className = "", onClick }) {
  const cls =
    `inline-flex cursor-pointer items-center justify-center gap-2 rounded-full bg-terracotta px-7 py-3.5 text-sm font-medium tracking-wide text-cream ` +
    `transition-[background-color,color,transform,box-shadow] duration-300 hover:-translate-y-0.5 hover:bg-gold hover:text-deepforest hover:shadow-md ${className}`;
  if (to) {
    return (
      <Link data-testid={testid} to={to} className={cls} onClick={onClick}>
        {children}
      </Link>
    );
  }
  return (
    <a
      data-testid={testid}
      href={href}
      className={cls}
      onClick={onClick}
      {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
    >
      {children}
    </a>
  );
}

export function GhostButton({ children, to, href, dark = false, testid, className = "" }) {
  const cls =
    `inline-flex cursor-pointer items-center justify-center gap-2 rounded-full border px-7 py-3.5 text-sm font-medium tracking-wide ` +
    (dark
      ? `border-cream/40 text-cream transition-[background-color,color,transform] duration-300 hover:-translate-y-0.5 hover:bg-cream hover:text-deepforest `
      : `border-forest text-forest transition-[background-color,color,transform] duration-300 hover:-translate-y-0.5 hover:bg-forest hover:text-cream `) +
    className;
  if (to) {
    return (
      <Link data-testid={testid} to={to} className={cls}>
        {children}
      </Link>
    );
  }
  return (
    <a data-testid={testid} href={href} className={cls} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  );
}
